var map = {
	"./add.png": "cae3",
	"./icon-footer-basketball.png": "13be",
	"./icon-footer-close.png": "e1af",
	"./icon-hkfc.png": "4a35",
	"./icon-search-grey.png": "a091",
	"./icon-star-grey.png": "92ae",
	"./icon_android.png": "fbf8",
	"./icon_apple.png": "8d9f",
	"./icon_arrow_down_black.png": "ceea",
	"./icon_arrow_down_white.png": "e725",
	"./icon_arrow_left.png": "3568",
	"./icon_arrow_left_double_white.png": "bae8",
	"./icon_arrow_left_white.png": "8ab2",
	"./icon_arrow_left_white_m.png": "611a",
	"./icon_arrow_right.png": "623e",
	"./icon_arrow_right_double_white.png": "5108",
	"./icon_arrow_right_white.png": "3d22",
	"./icon_avatar_default.png": "255e",
	"./icon_bracket.png": "4311",
	"./icon_bracket_back.png": "f1a9",
	"./icon_bracket_default.png": "4df9",
	"./icon_bracket_hover.png": "0ee3",
	"./icon_bracket_transparent.png": "3652",
	"./icon_calendar.png": "f663",
	"./icon_calendar_selected.png": "895d",
	"./icon_cancel_circle.png": "21ee",
	"./icon_close.png": "46c7",
	"./icon_close_grey.png": "96d6",
	"./icon_close_pwd.png": "6591",
	"./icon_close_white.png": "6869",
	"./icon_cog.png": "9e2e",
	"./icon_cog_active.png": "5d59",
	"./icon_comment_sent.png": "5a65",
	"./icon_comment_sent_colored.png": "0ded",
	"./icon_fav_selected.png": "a9c8",
	"./icon_fav_unselect.png": "100d",
	"./icon_fb.png": "8ff8",
	"./icon_filter.png": "ed35",
	"./icon_filter_float.png": "439d",
	"./icon_filter_selected.png": "af98",
	"./icon_filter_tick_selected.png": "8d5e",
	"./icon_filter_tick_unselect.png": "1dad",
	"./icon_filter_tick_white_selected.png": "1cda",
	"./icon_flag_empty.png": "a946",
	"./icon_flag_england.png": "f584",
	"./icon_football.png": "f6a0",
	"./icon_footer_basketball.png": "fb5e",
	"./icon_footer_close.png": "e83a",
	"./icon_footer_event_selected.png": "7a1b",
	"./icon_footer_event_unselect.png": "9a98",
	"./icon_footer_fantacy_1_selected.png": "dcb7",
	"./icon_footer_fantacy_1_unselect.png": "ee5e",
	"./icon_footer_fantasy_selected.png": "1178",
	"./icon_footer_fantasy_unselect.png": "ee9b",
	"./icon_footer_fav_selected.png": "cc7f",
	"./icon_footer_fav_unselect.png": "7ca9",
	"./icon_footer_fifa.png": "0750",
	"./icon_footer_fifa_selected.png": "f659",
	"./icon_footer_fifa_unselect.png": "f787",
	"./icon_footer_football.png": "0036",
	"./icon_footer_highlights_selected.png": "ffe1",
	"./icon_footer_highlights_unselect.png": "bcf1",
	"./icon_footer_hkfs_selected.png": "3ae5",
	"./icon_footer_hkfs_unselect.png": "5478",
	"./icon_footer_home_selected.png": "c19e",
	"./icon_footer_home_unselect.png": "2c74",
	"./icon_footer_more_unselect.png": "4a21",
	"./icon_footer_news_selected.png": "59a6",
	"./icon_footer_news_unselect.png": "ffd3",
	"./icon_footer_notification_unselect.png": "ce52",
	"./icon_footer_refresh.png": "67ea",
	"./icon_footer_sport_basketball_selected.png": "4c91",
	"./icon_footer_sport_football_selected.png": "803e",
	"./icon_goal_player.png": "d16c",
	"./icon_google_play.png": "3ee6",
	"./icon_h2h_alert.png": "2652",
	"./icon_highlight.png": "9af6",
	"./icon_highlight_detail.png": "8bf0",
	"./icon_highlight_mobile_header.png": "9e26",
	"./icon_highlight_selected.png": "07cc",
	"./icon_ig.png": "3547",
	"./icon_line.png": "97ce",
	"./icon_live_video_disabled.png": "77cf",
	"./icon_livevideo.png": "7428",
	"./icon_love_orange.png": "f8bf",
	"./icon_love_orange_selected.png": "98ba",
	"./icon_love_orrange.png": "e8a5",
	"./icon_mail.png": "1f2b",
	"./icon_match.png": "f412",
	"./icon_match_real_time_stats.png": "8a8d",
	"./icon_match_real_time_stats_selected.png": "2436",
	"./icon_match_tracker.png": "4d8a",
	"./icon_match_tracker_disabled.png": "844e",
	"./icon_match_tracker_selected.png": "18f2",
	"./icon_more.png": "f6bc",
	"./icon_news_author.png": "5a94",
	"./icon_notification_basketball.png": "5874",
	"./icon_notification_empty.png": "a0ad",
	"./icon_notification_football.png": "c8d1",
	"./icon_notification_grey.png": "1a2db",
	"./icon_notification_new.png": "acd2",
	"./icon_notification_selected.png": "fb11",
	"./icon_pencil.png": "4445",
	"./icon_play.png": "30c2",
	"./icon_play168.png": "77ce",
	"./icon_refresh.png": "adfb",
	"./icon_reply.png": "2d64",
	"./icon_search.png": "2f37",
	"./icon_show_pwd.png": "c8ec",
	"./icon_star.png": "5602",
	"./icon_star_black_solid.png": "7fdf",
	"./icon_star_blue_solid.png": "d478",
	"./icon_star_grey_hollow.png": "9fe5",
	"./icon_star_light_blue_solid_small.png": "a08b",
	"./icon_star_selected.png": "a527",
	"./icon_star_white.png": "ec9b",
	"./icon_star_white_hollow.png": "b2cc",
	"./icon_star_white_solid_small.png": "2c4c",
	"./icon_substitube_arrow_down.png": "9fe9",
	"./icon_substitube_arrow_up.png": "93bf",
	"./icon_team.png": "fd9f",
	"./icon_tick_green_selected.png": "14fe",
	"./icon_tick_selected.png": "ff41",
	"./icon_tick_unselect.png": "1fa5",
	"./icon_tick_white_disabled.png": "3081",
	"./icon_tick_white_selected.png": "2267",
	"./icon_tick_white_unselect.png": "2d98",
	"./icon_tiktok.png": "7508",
	"./icon_tiktok_black.png": "120d",
	"./icon_toastr_error_red.png": "1f22",
	"./icon_toastr_fav_added.png": "2bf4",
	"./icon_toastr_fav_removed.png": "1910",
	"./icon_toastr_selected.png": "7215",
	"./icon_twitter.png": "d809",
	"./icon_video_play.png": "1fab",
	"./icon_white_chevron_default_right.png": "0080",
	"./rectangle.png": "6033",
	"./social_media/icon_fb.png": "1b00",
	"./social_media/icon_line.png": "7100",
	"./social_media/icon_line_colored.png": "f21a",
	"./social_media/icon_share.png": "0001",
	"./social_media/icon_social_media_share.png": "693a",
	"./social_media/icon_twitter.png": "970b",
	"./social_media/icon_zalo_colored.png": "bcc6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bac4";